import React, { useEffect, useState } from 'react';

import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { Box } from '@mui/material';

export interface IOption {
    value: string;
    label: string;
    
}
const animatedComponents = makeAnimated();

 const SelectMulti: React.FC<{
    options  : IOption[],
    disabled? : boolean,
    oldValues?: IOption[],
    placeholder: string,
    onChange(options  : IOption[]): void
 }> = ({options, disabled, oldValues, placeholder, onChange}) => {

  const [defaultValue, setDefaultValue] = useState<IOption[]>([]);

  const handleChange = (selected:any) => {
    onChange(selected);
    setDefaultValue(selected)
  };

  
  useEffect(() => {
    console.log('oldValues', oldValues)
    if(oldValues)
      setDefaultValue(oldValues);
  }, []);
  useEffect(() => {
    console.log('oldValues', oldValues)
    if(oldValues)
      setDefaultValue(oldValues);
  }, [oldValues]);

  return (
    <Box component='div' style={{ width: "100%", flex: 1 }}>
      <Select
        isDisabled={disabled}
        placeholder={placeholder}
        closeMenuOnSelect={false}
        components={animatedComponents}
        onChange={handleChange}
        defaultValue={defaultValue}
        value={defaultValue}
        isMulti
        options={options}
      />
    </Box>
  );
}
export default SelectMulti